module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#instagram",
      toString: function () {
        return this.url;
      }
    }